import { LocalizedLink as Link } from '../../../components/LocalizedLink';
import { useTranslation } from 'react-i18next';
import Navbar from '../../home/components/Navbar';
import Footer from '../../home/components/Footer';

const WellnessRemoteWorkPage = () => {
  const relatedPosts = [
    {
      id: 1,
      title: 'Construyendo equipos remotos de alto rendimiento',
      image: '/assets/images/blog/remote-teams-blog.jpg',
      link: '/blog/remote-teams',
    },
    {
      id: 2,
      title: 'Cómo la Inteligencia Artificial está transformando el Marketing Digital',
      image: '/assets/images/blog/ai-marketing-blog.jpg',
      link: '/blog/ai-transforming-marketing',
    },
    {
      id: 3,
      title: 'No es otro artículo sobre cultura organizacional',
      image: '/assets/images/blog/org-culture-blog.jpg',
      link: '/blog/organizational-culture',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="pt-32 pb-12 px-6">
        <div className="max-w-4xl mx-auto">
          <div className="mb-8">
            <Link
              to="/blog"
              className="inline-flex items-center gap-2 text-sm text-emerald-500 hover:text-emerald-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-arrow-left-line w-4 h-4 flex items-center justify-center"></i>
              Volver al Blog
            </Link>
          </div>

          <div className="flex items-center gap-3 mb-6">
            <span className="px-4 py-1.5 bg-emerald-50 text-emerald-600 text-sm font-medium rounded-full whitespace-nowrap">
              Trabajo Remoto
            </span>
            <span className="text-sm text-gray-500">3 minutos de lectura</span>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-8 leading-tight">
            Bienestar en el trabajo remoto: Ideas para equilibrar trabajo y vida personal, ejercicios de estiramiento o meditación.
          </h1>

          <div className="flex items-center gap-4 mb-12">
            <img
              src="https://secure.gravatar.com/avatar/4df797a636183055eb30e6104249e7db?s=64&d=mm&r=g"
              alt="Liliana Ferro"
              className="w-12 h-12 rounded-full"
            />
            <div>
              <p className="text-sm font-semibold text-gray-900">Por Liliana Ferro</p>
              <p className="text-sm text-gray-500">2 diciembre, 2024</p>
            </div>
          </div>

          <div className="aspect-[16/9] w-full overflow-hidden rounded-2xl mb-12">
            <img
              src="/assets/images/blog/wellness-blog.jpg"
              alt="Bienestar en el trabajo remoto"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </section>

      {/* Related Articles */}
      <section className="py-20 px-6 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">Artículos relacionados</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {relatedPosts.map((post) => (
              <article
                key={post.id}
                className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 group cursor-pointer"
              >
                <Link to={post.link} className="block">
                  <div className="aspect-[4/3] overflow-hidden w-full h-full">
                    <img
                      src={post.image}
                      alt={post.title}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                    />
                  </div>
                  <div className="p-6">
                    <h4 className="text-lg font-bold text-gray-900 line-clamp-2 group-hover:text-emerald-500 transition-colors">
                      {post.title}
                    </h4>
                  </div>
                </Link>
              </article>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default WellnessRemoteWorkPage;
